exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".k1MP3-jeXNtGGD{width:220px;height:72px;background-color:#fff;border:1px solid #dfe1e6;border-radius:3px;position:relative;overflow:hidden}._1KPOocjy__qHH6{display:flex;flex-direction:column;height:46px;position:absolute;margin-top:12px;margin-left:16px;justify-content:space-between}._2-y1-0OAnPCxxt{color:#172b4d;letter-spacing:-.01px;line-height:16px;font-size:12px}._2-JJ6lVslMQ2vF{color:#42526e;font-size:12px;line-height:16px;text-decoration:underline}._2eEzP77PW4vCIE{overflow:hidden;margin-top:39px}._1Kmpcc3a4pLCoY{position:absolute;width:50px;height:50px;background:rgba(0,121,191,.08);border-radius:12px;transform:rotate(40deg);margin-top:5px;margin-left:177px}._2gPsgUjw0CPxvT{position:absolute;width:22px;height:22px;background-color:#0079bf;border-radius:3px;margin-left:188px;margin-top:5px}.-CfVFbQREJhwH0{margin-left:184px;margin-top:0;position:absolute}", ""]);

// exports
exports.locals = {
	"bannerContainer": "k1MP3-jeXNtGGD",
	"bannerMessage": "_1KPOocjy__qHH6",
	"bannerHeader": "_2-y1-0OAnPCxxt",
	"bannerText": "_2-JJ6lVslMQ2vF",
	"hideOverflow": "_2eEzP77PW4vCIE",
	"bannerAccent": "_1Kmpcc3a4pLCoY",
	"trelloLogo": "_2gPsgUjw0CPxvT",
	"trelloTemplateIcon": "-CfVFbQREJhwH0"
};